import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ImageLightbox({ src, onClose }) {
  return (
    <Modal open={Boolean(src)} onClose={onClose}>
      <Box
        onClick={onClose}
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(0, 0, 0, 0.85)",
          outline: "none",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            insetInlineEnd: 12,
            color: "#fff",
            bgcolor: "rgba(255, 255, 255, 0.12)",
            "&:hover": { bgcolor: "rgba(255, 255, 255, 0.24)" },
          }}
        >
          <CloseIcon />
        </IconButton>
        {src && (
          <Box
            component="img"
            src={src}
            alt=""
            onClick={(e) => e.stopPropagation()}
            sx={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: 1,
            }}
          />
        )}
      </Box>
    </Modal>
  );
}
